import Vue from 'vue';
import {
  Button,
  Form,
  Input,
  Icon,
  ConfigProvider,
  Alert,
  Layout,
  Menu,
  Dropdown,
  Table,
  Card,
  Spin,
  Select,
  Empty,
  DatePicker,
  Rate,
  FormModel,
  Drawer,
  Modal,
  Popconfirm,
  Switch,
  Tag,
  Popover,
  Radio,
  Avatar,
  Comment,
  Tooltip,
  InputNumber,
  Collapse,
  List,
  Breadcrumb,
  Pagination,
  Timeline,
  Checkbox,
  Steps,
  Upload,
  Result,
  Tabs,
  Cascader,
  Row,
  Col,
  Divider,
  Badge,
  message,
  notification,
} from 'ant-design-vue';

Vue.use(Button);
Vue.use(Form);
Vue.use(Input);
Vue.use(Icon);
Vue.use(Alert);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(ConfigProvider);
Vue.use(Dropdown);
Vue.use(Table);
Vue.use(Card);
Vue.use(Spin);
Vue.use(Select);
Vue.use(DatePicker);
Vue.use(Rate);
Vue.use(Empty);
Vue.use(FormModel);
Vue.use(Drawer);
Vue.use(Modal);
Vue.use(Popconfirm);
Vue.use(Switch);
Vue.use(Tag);
Vue.use(Radio);
Vue.use(Popover);
Vue.use(Avatar);
Vue.use(Comment);
Vue.use(Tooltip);
Vue.use(InputNumber);
Vue.use(Collapse);
Vue.use(List);
Vue.use(Breadcrumb);
Vue.use(Pagination);
Vue.use(Timeline);
Vue.use(Checkbox);
Vue.use(Steps);
Vue.use(Upload);
Vue.use(Result);
Vue.use(Tabs);
Vue.use(Cascader);
Vue.use(Row);
Vue.use(Col);
Vue.use(Divider);
Vue.use(Badge);
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$notification = notification;
